import React, { useEffect, useState, useRef } from 'react';
import './styles/Pages.css';
import axios from 'axios';

const Professional = () => {
    
    const [currentText, setCurrentText] = useState('');
    const [textIndex, setTextIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const bgContentRef = useRef(null);
    const [texts, setTexts] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    
    //Cargar los textos
    useEffect(() => {
        axios.get('https://www.noecer.com/api/portfolio/features/getdata')
            .then(response => {
                // Sólo textos habilitados
                const filteredTexts = response.data
                    .filter(item => item.enabled)
                    .map(item => item.name);
                setTexts(filteredTexts);
                setIsLoading(false);
                console.log(texts);
            })
            .catch((error)=>{
                setIsLoading(false); 
                console.error("Hubo un error consultando el API de JAVA",error);
            });
    }, []);

    //Animación
   useEffect(() => {
        if (isLoading || texts.length === 0) return;

        let typingSpeed = 100;
        let erasingSpeed = 50;
        let pauseBeforeDeleting = 2000;

        const fullText = texts[textIndex];

        const timeoutId = setTimeout(() => {
            if (!isDeleting && currentText.length < fullText.length) {
                setCurrentText(fullText.slice(0, currentText.length + 1));
            } else if (isDeleting && currentText.length > 0) {
                setCurrentText(currentText.slice(0, currentText.length - 1));
            } else if (isDeleting && currentText.length === 0) {
                setIsDeleting(false);
                setTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
            } else if (!isDeleting && currentText.length === fullText.length) {
                // Esperar antes de borrar
                setTimeout(() => setIsDeleting(true), pauseBeforeDeleting);
            }
        }, isDeleting ? erasingSpeed : typingSpeed);

        return () => clearTimeout(timeoutId);
    }, [currentText, isDeleting, textIndex, texts, isLoading]);

    return (
        <div className='professional'>
            <p>&nbsp;{currentText}</p>
            <div className="cover2">
                <div id="bg-content" ref={bgContentRef}>
                    <section className="inner">
                        {/* Your inner content here */}
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Professional;
